import { render, staticRenderFns } from "./SelectedOptions.vue?vue&type=template&id=f0987ff0&scoped=true&"
import script from "./SelectedOptions.vue?vue&type=script&lang=js&"
export * from "./SelectedOptions.vue?vue&type=script&lang=js&"
import style0 from "./SelectedOptions.vue?vue&type=style&index=0&id=f0987ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0987ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VFlex,VIcon,VLayout})
